import { ElementType } from 'react'

import { Box } from '../../components/Box'

import { ImageProps } from './types'

export const Image = <C extends ElementType>(props: ImageProps<C>) => (
  <Box className="promo-card__image" {...props} />
)
